/**
 * Symbol taxonomy — mirror of backend/services/symbols.py.
 *
 * Kept small; extend both files in lockstep when we add markets.
 */

export const FRIENDLY_NAMES = {
  "GC=F": "GOLD (COMEX)",
  "SI=F": "SILVER (COMEX)",
  "EURUSD=X": "EUR/USD",
  "GBPUSD=X": "GBP/USD",
  "USDJPY=X": "USD/JPY",
  "AUDUSD=X": "AUD/USD",
  "USDCAD=X": "USD/CAD",
  "USDCHF=X": "USD/CHF",
  "BTC-USD": "Bitcoin",
  "ETH-USD": "Ethereum",
  "SOL-USD": "Solana",
};

const ETF_SET = new Set([
  "SPY","QQQ","GLD","SLV","USO","UUP","FXE","IWM","DIA",
  "TLT","HYG","LQD","EEM","EFA","VTI","VOO",
]);

export function friendlyName(symbol, fallback) {
  const s = String(symbol || "").toUpperCase().trim();
  return FRIENDLY_NAMES[s] || fallback || s;
}

export function assetClass(symbol) {
  const s = String(symbol || "").toUpperCase().trim();
  if (s.endsWith("-USD") || s.endsWith("-USDT")) return "crypto";
  if (s.endsWith("=X")) return "fx";
  if (s.endsWith("=F")) return "future";
  if (ETF_SET.has(s)) return "etf";
  return "stock";
}

export function isFx(symbol) { return assetClass(symbol) === "fx"; }
export function isFuture(symbol) { return assetClass(symbol) === "future"; }
export function isCrypto(symbol) { return assetClass(symbol) === "crypto"; }
export function isJpyPair(symbol) {
  const s = String(symbol || "").toUpperCase().trim();
  return s.endsWith("=X") && s.includes("JPY");
}

/** Number of decimals for price display. */
export function pricePrecision(symbol) {
  const cls = assetClass(symbol);
  if (cls === "fx") return isJpyPair(symbol) ? 3 : 4;
  if (cls === "future") return 2;
  if (cls === "crypto") return 2;
  return 2;
}

/** Format a numeric price with the right precision for its asset class. */
export function formatPrice(symbol, price) {
  if (price == null || Number.isNaN(Number(price))) return "—";
  const p = Number(price);
  const decimals = pricePrecision(symbol);
  // Very small crypto (< $1) or tokens: bump to 6 decimals.
  if (assetClass(symbol) === "crypto" && p < 1) return p.toFixed(6);
  return p.toFixed(decimals);
}
